/**
 * Открыть плавающий «+» (components/HelpFab) откуда угодно: «Создать ▾» в шапке,
 * пустой поиск. `menu` — стопка плашек, остальное — сразу форма / список.
 * Раньше то же делал `openHubRequest` окна «Написать в УК» (RequestModal).
 */
export type FeedbackView = 'menu' | 'question' | 'bug' | 'idea' | 'mine';

export const HUB_FEEDBACK_EVENT = 'fk-hub-feedback';

export function openHubFeedback(view: FeedbackView = 'menu'): void {
  window.dispatchEvent(new CustomEvent<{ view: FeedbackView }>(HUB_FEEDBACK_EVENT, { detail: { view } }));
}

const VIEWS: readonly FeedbackView[] = ['menu', 'question', 'bug', 'idea', 'mine'];

/** Вид из события: чужое значение — стопка плашек. */
export function feedbackViewOf(detail: unknown): FeedbackView {
  const v = (detail as { view?: unknown } | null | undefined)?.view;
  return VIEWS.includes(v as FeedbackView) ? (v as FeedbackView) : 'menu';
}
